import type { DashboardItem } from './types'

/** A stable key for one line of the agenda or of Achterstallig. */
export function itemKey(item: DashboardItem): string {
  return item.task_id ?? item.occurrence_id ?? `${item.kind}:${item.date}:${item.title}`
}
